import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from 'src/components/Box';
import { Button } from 'src/components/Button';
import { ServerRole } from 'src/orchd-client';
import { ServerSelectNew } from 'src/components/ServerSelect/ServerSelectNew';
import { ServerGroupSelector } from '../websites/add-website/ServerGroupSelector/ServerGroupSelector';
import { FormType } from 'src/containers/Form';
import { GithubWebsiteDeployFormShape } from './DeployToWebsite';
import { Subscription } from 'src/orchd-client';
import { zIndex } from 'src/utils/zIndex';
import { messages } from 'src/messages';

interface Props {
  form: FormType<GithubWebsiteDeployFormShape>;
  isMasterOrg: boolean;
  subscriptions: Subscription[] | undefined;
  placementOpen: boolean;
  onToggle: () => void;
}

export const ServerPlacementSection = ({ form, isMasterOrg, subscriptions, placementOpen, onToggle }: Props) => {
  const showServerPlacement =
    isMasterOrg ||
    (form.values?.newWebsite?.subscriptionId &&
      subscriptions?.find((sub) => sub.id === form.values?.newWebsite?.subscriptionId)?.serverGroups?.length > 0);

  if (!showServerPlacement) {
    return null;
  }

  return (
    <>
      <Button
        onClick={onToggle}
        variant="tertiary"
        icon={placementOpen ? 'chevron up' : 'chevron down'}
        marginBottom="lg"
        iconPosition="right"
        size="small"
      >
        <FormattedMessage {...messages.server_placement} />
      </Button>
      {placementOpen && (
        <Box w={12} g="lg" zIndex={zIndex.AvatarLoading}>
          {isMasterOrg ? (
            <Box g="lg">
              <Box w={{ xs: 12, md: 6 }} mb="lg">
                <ServerSelectNew
                  currentId={form.values.newWebsite?.appServerId}
                  role={ServerRole.application}
                  setId={(val) => {
                    form.setFieldValue('newWebsite.appServerId', val);
                  }}
                />
              </Box>
              <Box w={{ xs: 12, md: 6 }} mb="lg">
                <ServerSelectNew
                  currentId={form.values.newWebsite?.dbServerId}
                  role={ServerRole.database}
                  setId={(val) => {
                    form.setFieldValue('newWebsite.dbServerId', val);
                  }}
                />
              </Box>
              <Box w={{ xs: 12, md: 6 }} mb="lg">
                <ServerSelectNew
                  currentId={form.values.newWebsite?.postgresqlServerId}
                  role={ServerRole.postgresql}
                  setId={(val) => {
                    form.setFieldValue('newWebsite.postgresqlServerId', val);
                  }}
                />
              </Box>
              <Box w={{ xs: 12, md: 6 }} mb="lg">
                <ServerSelectNew
                  currentId={form.values.newWebsite?.emailServerId}
                  role={ServerRole.email}
                  setId={(val) => {
                    form.setFieldValue('newWebsite.emailServerId', val);
                  }}
                />
              </Box>
              <Box w={{ xs: 12, md: 6 }} mb="lg">
                <ServerSelectNew
                  currentId={form.values.newWebsite?.backupServerId}
                  role={ServerRole.backup}
                  setId={(val) => {
                    form.setFieldValue('newWebsite.backupServerId', val);
                  }}
                />
              </Box>
            </Box>
          ) : (
            (() => {
              const selectedSubscription = subscriptions?.find(
                (sub) => sub.id === form.values?.newWebsite?.subscriptionId
              );
              if (!selectedSubscription?.serverGroups || selectedSubscription.serverGroups.length === 0) {
                return null;
              }
              return (
                <ServerGroupSelector
                  serverGroups={selectedSubscription.serverGroups}
                  currentServerGroupId={form.values?.newWebsite?.serverGroupId}
                  onServerGroupChange={(val) => {
                    form.setFieldValue('newWebsite.serverGroupId', val);
                  }}
                />
              );
            })()
          )}
        </Box>
      )}
    </>
  );
};
